import React, { Component } from 'react';
import Header from '../Header';
// import MessageLink from '../MessageLink';
// import Footer from '../Footer';
// import BannerSingle from '../BannerSingle';
// import PageDescription from '../PageDescription';
// import Lgpd from '../Lgpd';


class NotFound extends Component {

	render() {

		return (


			<div>
				{/* HEADER */}{/* LOGIN */}
				<Header />

				{
					<>
						<section className="page-banner text-white position-relative bg-dark small">
							<div className='container h-100'>
								<div className='row h-100 align-items-center justify-content-center'>
									<div className='col-md-8 col-lg-9 mt-lg-10'>
										<h2 className="mt-10"> Sua atualização cadastral deverá ser feita junto ao RH da patrocinadora. </h2>
									</div>
								</div>
							</div>
						</section>

						<div className="_the-content page-404 py-6 py-lg-10 my-10 ">
							<div className='container'>
								<div className="row justify-content-center">
									<div className="col-lg-8">
										<h3> Posteriormente, os dados atualizados serão reproduzidos no sistema da Forluz. </h3>
										<p></p>

									</div>
								</div>
							</div>
						</div>
					</>
				}
			</div>
		);
	}
};

export default NotFound;